import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle, ArrowRight, Download } from "lucide-react";

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const paymentId = searchParams.get("payment_id");

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Success Icon */}
        <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
          <CheckCircle className="h-12 w-12 text-green-600" />
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Payment Successful!
        </h1>

        {/* Description */}
        <p className="text-gray-600 mb-8">
          Thank you for your payment. Your subscription is now active and you
          have full access to all features.
        </p>

        {/* Payment Details Card */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 mb-8 text-left">
          <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wide mb-4">
            Payment Details
          </h3>

          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600">Status</span>
              <span className="font-medium text-green-600">Confirmed</span>
            </div>
            {paymentId && (
              <div className="flex justify-between">
                <span className="text-gray-600">Payment ID</span>
                <span className="font-mono text-sm text-gray-900">
                  {paymentId}
                </span>
              </div>
            )}
            <div className="flex justify-between">
              <span className="text-gray-600">Date</span>
              <span className="text-gray-900">
                {new Date().toLocaleDateString("en-IN", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </span>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="space-y-3">
          <button
            onClick={() => navigate("/dashboard")}
            className="w-full inline-flex items-center justify-center rounded-lg bg-indigo-600 px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 transition-colors"
          >
            Go to Dashboard
            <ArrowRight className="ml-2 h-4 w-4" />
          </button>

          <button
            onClick={() => navigate("/subscription/history")}
            className="w-full inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50 transition-colors"
          >
            <Download className="mr-2 h-4 w-4" />
            View Payment History
          </button>
        </div>

        {/* Support Link */}
        <p className="mt-8 text-sm text-gray-500">
          Have questions?{" "}
          <a
            href="mailto:support@medicorepay.com"
            className="text-indigo-600 hover:text-indigo-700"
          >
            Contact Support
          </a>
        </p>
      </div>
    </div>
  );
}
